import { driverDeviceActionSchema } from '@chukua/common';
import { Button, Form, Input, Modal } from 'antd';
import { useState } from 'react';

interface ReasonModalProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  onCancel: () => void;
  /** Resolves true when the server accepted it. */
  onConfirm: (reason: string) => Promise<boolean>;
}

/** The office must say why: the reason goes into the audit trail beside who asked. */
export function ReasonModal({ open, title, description, confirmLabel, onCancel, onConfirm }: ReasonModalProps) {
  const [form] = Form.useForm<{ reason: string }>();
  const [submitting, setSubmitting] = useState(false);

  async function submit({ reason }: { reason: string }) {
    setSubmitting(true);
    try {
      if (await onConfirm(reason.trim())) form.resetFields();
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Modal open={open} title={title} onCancel={onCancel} footer={null} destroyOnClose>
      <p className="mb-4 text-sm text-muted">{description}</p>
      <Form<{ reason: string }> form={form} layout="vertical" requiredMark={false} onFinish={submit} disabled={submitting}>
        <Form.Item
          name="reason"
          label="Reason"
          rules={[
            {
              validator: async (_, value: string | undefined) => {
                const parsed = driverDeviceActionSchema.safeParse({ reason: value ?? '' });
                if (!parsed.success) throw new Error(parsed.error.issues[0].message);
              },
            },
          ]}
        >
          <Input.TextArea rows={3} maxLength={500} />
        </Form.Item>
        <Form.Item className="mb-0 flex justify-end">
          <Button type="primary" danger htmlType="submit" loading={submitting}>
            {confirmLabel}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
